<nav class="navbar navbar-expand navbar-light" #navHeader [style.height.px]="navHeight">
  <div class="container-fluid">
    <ul class="navbar-nav navbar-collapse flex-wrap">
      <ng-container *ngFor="let filter of (columnFiltersObservable | async)">
        <asax-result-table-vo-table-column-filter [columnFilter]="filter"
                                                  (outColumnFilter)="onColumnFilter($event)"
                                                  (outRemoveColumnFilter)="onRemoveColumnFilter($event)">
        </asax-result-table-vo-table-column-filter>
      </ng-container>
      <ng-container *ngIf="displayRemove | async">
        <li class="nav-item me-1">
          <button 
            class="btn btn-sm btn-light border-dark"
            (click)="removeColumnFilters()"
            placement="bottom"
            ngbTooltip="Remove all tab filters"
            >
              <i class="fa fa-times"></i>
        </button>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
<div class="position-relative">
  <ngx-datatable class="vo-result-table ngx-datatable material striped"
                 [style.height.px]="height - navHeader.offsetHeight"
                 [scrollbarH]="true"
                 [scrollbarV]="true"
                 [messages]="{emptyMessage: '', totalMessage: ''}"
                 [rows]="rows"
                 [columnMode]="ColumnMode.force"
                 [headerHeight]="headerHeight"
                 [footerHeight]="0"
                 [rowHeight]="30"
                 [reorderable]="reorderable">
    <ng-container *ngFor="let column of columns">
      <ngx-datatable-column [id]="column.id"
                            [name]="column.name"
                            [prop]="column.prop">
        <ng-template ngx-datatable-header-template let-sort="sortFn" let-sortDir="sortDir">
          <asax-result-table-vo-table-column-header-container [column]="column"
                                                              [sortDir]="sortDir"
                                                              (outSort)="sort()">
          </asax-result-table-vo-table-column-header-container>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
          <ng-container *ngIf="value?.toString()?.startsWith('http'); else textValue">
            <a [href]="value" target="_blank">{{value}}</a>
          </ng-container>
          <ng-template #textValue>
            {{value}}
          </ng-template>
        </ng-template>
      </ngx-datatable-column>
    </ng-container>
  </ngx-datatable>
</div>
